{
  "languages": {
    "en": "English",
    "es": "Español",
    "it": "Italiano"
  },
  "labels": {
    "language": "Language",
    "source": "Source",
    "license": "License",
    "format": "Format",
    "keywords": "Keywords",
    "relevance": "Relevance",
    "relevanceLevels": {
      "low": "Low",
      "medium": "Medium",
      "high": "High"
    },
    "size": "Size",
    "all": "All",
    "cancel": "Cancel",
    "saved": "Saved",
    "description": "Description",
    "page": "Page",
    "of": "of",
    "save": "Save",
    "download": "Download",
    "details": "Details",
    "add": "Add",
    "datasource": "Datasource",
    "datasource-name": "Datasource name",
    "file-name": "File name",
    "file-url": "File URL",
    "column-count": "Column count",
    "row-count": "Row count",
    "columns": "Columns",
    "column-name": "Column name",
    "column-type": "Column type",
    "errors": "Errors",
    "no-errors": "No errors",
    "created-at": "Created at",
    "updated-at": "Updated at"
  },
  "strings": {
    "data-discovery": "Data Discovery",
    "deep-search": "Deep Search",
    "add-keywords": "Add keywords",
    "available-files": "Available Files",
    "relevance-score": "Relevance Score",
    "relevance-chip-tooltip": "Relevance: {value}",
    "min-relevance": "Min Relevance",
    "max-relevance": "Max Relevance",
    "min-size": "Min Size",
    "max-size": "Max Size",
    "size-hint": "Size in KB (filters individual files)",
    "saved-datasets": "Saved Datasets",
    "search-data-sources": "Data Sources Search",
    "deep-search-hint": "A deep search will give you many more results",
    "search-completed": "Search completed",
    "results-found": "results found",
    "no-search-performed": "Start searching for datasets using the search form above",
    "no-results-found": "No results found. Try adjusting your search query or filters.",
    "no-files-available": "No files available for this dataset",
    "relevance-hint": "A pair of values ​​between 0 and 10",
    "relevance-hint-categorical": "A pair of values across the configured relevance levels",
    "download-cors-error": "Direct download not available for external files.",
    "download-fallback": "The file was handled by the browser (opened or downloaded).",
    "download-open-failed": "Unable to open the file in a new tab.",
    "download-invalid-url": "Invalid file URL.",
    "add-endpoint": "Add Endpoint",
    "add-to-new-datasource": "Add to a new datasource",
    "add-to-existing-datasource": "Add to an existing datasource",
    "no-datasources-available": "No datasources available.",
    "no-file-selected": "No file selected.",
    "value-required": "Value is required.",
    "no-details-available": "Details not available for this file.",
    "details-failed": "Details failed. Please try again.",
    "no-saved-datasets": "No saved datasets yet",
    "save-datasets-hint": "Click the bookmark icon on any dataset to save it temporarily for this search session",
    "datasets-saved": "datasets saved",
    "confirm-clear-all": "Clear All Saved Datasets?",
    "confirm-clear-all-message": "Are you sure you want to remove all saved datasets? This action cannot be undone.",
    "view-dataset": "View Dataset",
    "show-details": "Show details",
    "hide-details": "Hide details",
    "clear-filters": "Clear Filters",
    "back-to-search": "Back to Search",
    "clear-all": "Clear All",
    "datasource-name-hint": "Write a name for your datasource",
    "datasource-project-description": "Write a brief description of datasource",
    "redirect-warning": "By proceeding you will be redirected to the Datasources section and the search will be reset. If you prefer to stay here, the creation will continue in the background.",
    "redirect-choice": "Redirect me to Datasources after creation",
    "datasource-created-success": "Datasource created successfully!",
    "dataset-added-success": "Dataset added successfully!",
    "datasource-and-dataset-created-success": "Datasource and dataset created successfully!"
  }
}
